import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router";
import Routes from './components/Routes'

import './helpers/axios';
import './index.scss';
import {UserProvider} from "./context/user.context";
import {WebsocketProvider} from "./context/websocket.context";
import {AlertProvider} from "./context/alert.context";


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <BrowserRouter>
        <AlertProvider>
            <WebsocketProvider>
                <Routes/>
            </WebsocketProvider>
        </AlertProvider>
    </BrowserRouter>
);

